"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

var react_input_verification_code_1 = __importDefault(require("react-input-verification-code"));

var style_1 = require("./style");

function InputCodigoVerificacion(props) {
  var classes = (0, style_1.styles)(); //styles() es una funcion que se creó con makeStyles en style.ts

  var disabled = props.disabled,
      error = props.error;

  var propsDefault = __assign({}, props); //Defino una variable que contiene las classes que va a modificarse condicionalmente


  var conditionalStyle = classes.customStyles;

  if (error) {
    conditionalStyle = classes.customStylesOnError;
  } else if (disabled) {
    conditionalStyle = classes.customStylesDisabled;
  }

  return react_1["default"].createElement("div", {
    className: conditionalStyle
  }, react_1["default"].createElement(react_input_verification_code_1["default"], __assign({}, propsDefault)));
}

exports["default"] = InputCodigoVerificacion;